"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnchorController = void 0;
/**
 * portal로 옮겨져 기준 요소의 자손이 아닌 표면이, 기준 요소의 화면 좌표를 CSS 변수로 받게 하는 ReactiveController.
 *
 * 열려 있는 동안 렌더가 끝날 때마다, 그리고 scroll·resize마다 좌표를 다시 재고 host에 싣는다.
 * 놓이는 자리는 CSS가 이 변수로 정하므로 컨트롤러는 어느 모서리에 맞출지 모른다.
 * scroll·resize 리스너는 열려 있는 동안에만 걸고 닫히거나 연결이 끊기면 대칭으로 정리하므로,
 * 닫힌 표면이 window 이벤트마다 깨어나지 않는다.
 */
class AnchorController {
    constructor(host, options) {
        this.host = host;
        this.options = options;
        this.handleViewportChange = () => {
            this.measure();
        };
        host.addController(this);
    }
    hostConnected() {
        this.syncListeners();
    }
    hostUpdated() {
        this.syncListeners();
        this.measure();
    }
    hostDisconnected() {
        this.unlisten();
    }
    // 같은 리스너를 같은 옵션으로 다시 걸어도 한 번만 등록되므로 열려 있는 동안 반복 호출해도 안전하다.
    syncListeners() {
        if (!this.options.isOpen()) {
            this.unlisten();
            return;
        }
        window.addEventListener('scroll', this.handleViewportChange, { capture: true, passive: true });
        window.addEventListener('resize', this.handleViewportChange);
    }
    unlisten() {
        window.removeEventListener('scroll', this.handleViewportChange, { capture: true });
        window.removeEventListener('resize', this.handleViewportChange);
    }
    measure() {
        if (!this.options.isOpen())
            return;
        const anchor = this.options.getAnchor();
        if (!anchor)
            return;
        const rect = anchor.getBoundingClientRect();
        const edges = Object.entries(this.options.variables);
        for (const [edge, variable] of edges)
            this.host.style.setProperty(variable, `${rect[edge]}px`);
    }
}
exports.AnchorController = AnchorController;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYW5jaG9yLWNvbnRyb2xsZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJhbmNob3ItY29udHJvbGxlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFjQTs7Ozs7OztHQU9HO0FBQ0gsTUFBYSxnQkFBZ0I7SUFDM0IsWUFBb0IsSUFBVSxFQUFVLE9BQXNCO1FBQTFDLFNBQUksR0FBSixJQUFJLENBQU07UUFBVSxZQUFPLEdBQVAsT0FBTyxDQUFlO1FBaUN0RCx5QkFBb0IsR0FBRyxHQUFHLEVBQUU7WUFDbEMsSUFBSSxDQUFDLE9BQU8sRUFBRSxDQUFBO1FBQ2hCLENBQUMsQ0FBQTtRQWxDQyxJQUFJLENBQUMsYUFBYSxDQUFDLElBQUksQ0FBQyxDQUFBO0lBQzFCLENBQUM7SUFFRCxhQUFhO1FBQ1gsSUFBSSxDQUFDLGFBQWEsRUFBRSxDQUFBO0lBQ3RCLENBQUM7SUFFRCxXQUFXO1FBQ1QsSUFBSSxDQUFDLGFBQWEsRUFBRSxDQUFBO1FBQ3BCLElBQUksQ0FBQyxPQUFPLEVBQUUsQ0FBQTtJQUNoQixDQUFDO0lBRUQsZ0JBQWdCO1FBQ2QsSUFBSSxDQUFDLFFBQVEsRUFBRSxDQUFBO0lBQ2pCLENBQUM7SUFFRCwyREFBMkQ7SUFDbkQsYUFBYTtRQUNuQixJQUFJLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxNQUFNLEVBQUUsRUFBRTtZQUMxQixJQUFJLENBQUMsUUFBUSxFQUFFLENBQUE7WUFDZixPQUFNO1NBQ1A7UUFFRCxNQUFNLENBQUMsZ0JBQWdCLENBQUMsUUFBUSxFQUFFLElBQUksQ0FBQyxvQkFBb0IsRUFBRSxFQUFFLE9BQU8sRUFBRSxJQUFJLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxDQUFDLENBQUE7UUFDOUYsTUFBTSxDQUFDLGdCQUFnQixDQUFDLFFBQVEsRUFBRSxJQUFJLENBQUMsb0JBQW9CLENBQUMsQ0FBQTtJQUM5RCxDQUFDO0lBRU8sUUFBUTtRQUNkLE1BQU0sQ0FBQyxtQkFBbUIsQ0FBQyxRQUFRLEVBQUUsSUFBSSxDQUFDLG9CQUFvQixFQUFFLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxDQUFDLENBQUE7UUFDbEYsTUFBTSxDQUFDLG1CQUFtQixDQUFDLFFBQVEsRUFBRSxJQUFJLENBQUMsb0JBQW9CLENBQUMsQ0FBQTtJQUNqRSxDQUFDO0lBTU8sT0FBTztRQUNiLElBQUksQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLE1BQU0sRUFBRTtZQUFFLE9BQU07UUFFbEMsTUFBTSxNQUFNLEdBQUcsSUFBSSxDQUFDLE9BQU8sQ0FBQyxTQUFTLEVBQUUsQ0FBQTtRQUN2QyxJQUFJLENBQUMsTUFBTTtZQUFFLE9BQU07UUFFbkIsTUFBTSxJQUFJLEdBQUcsTUFBTSxDQUFDLHFCQUFxQixFQUFFLENBQUE7UUFDM0MsTUFBTSxLQUFLLEdBQUcsTUFBTSxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLFNBQVMsQ0FBMkIsQ0FBQTtRQUM5RSxLQUFLLE1BQU0sQ0FBQyxJQUFJLEVBQUUsUUFBUSxDQUFDLElBQUksS0FBSztZQUFFLElBQUksQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLFdBQVcsQ0FBQyxRQUFRLEVBQUUsR0FBRyxJQUFJLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFBO0lBQ2hHLENBQUM7Q0FDRjtBQWhERCw0Q0FnREMifQ==